import { FC } from 'react';

import { MOCK_PATIENTS } from '../../__mock.ts';
import { TPatientType } from '../../types.ts';

import { useColumnsVisibility } from '@/contexts/column-visibility';
import { PaginatedTable } from '@/widgets/paginated-table';

export const PatientsTable: FC = () => {
    const { visibleColumns } = useColumnsVisibility<TPatientType>();

    return (
        <PaginatedTable
            columns={visibleColumns}
            dataSource={MOCK_PATIENTS}
            total={MOCK_PATIENTS.length}
        />
    );
};
